import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'

const Container = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: normal;
`

const Subtext = styled(Caption).attrs({
  colour: 'critical' as const,
  align: 'center' as const,
})`
  display: block;
  margin-top: ${rem(2)};
`

function AbTestsButtonLabel() {
  const intl = useIntl()
  return (
    <Container>
      {intl.formatMessage({
        id: 'G3lag2Ak-XznBrD6naq8',
        defaultMessage: 'AB Tests',
        description: 'Label for the AB Tests button in the header',
      })}
      <Subtext variant="small">
        {intl.formatMessage({
          id: 'CwzpkF5UxVvPNvwwThiX',
          defaultMessage: 'Only visible for staff',
          description: 'Subtext indicating AB Tests button is only visible to staff',
        })}
      </Subtext>
    </Container>
  )
}

export default AbTestsButtonLabel
